import { useEffect, useMemo, type ReactNode } from 'react';
import { resolveLocale } from '@debtbot/shared';
import { useMe } from '../api/hooks';
import { LocaleContext, setLocale } from '../i18n';

/**
 * Язык: явный выбор пользователя (/me.preferred_language) → язык Telegram → ru.
 * До загрузки /me — язык из initData, чтобы первый экран не мигал.
 */
export function LocaleProvider({
  telegramLanguage,
  children,
}: {
  telegramLanguage: string | null;
  children: ReactNode;
}) {
  const me = useMe();
  const locale = useMemo(
    () =>
      resolveLocale(
        me.data?.preferred_language ?? null,
        me.data?.language_code ?? telegramLanguage,
      ),
    [me.data?.preferred_language, me.data?.language_code, telegramLanguage],
  );
  // модульное состояние для форматтеров — синхронно с рендером
  setLocale(locale);
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);
  return <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>;
}
